<template>
  <ValidationObserver v-slot="{ invalid }">
    <b-form class="1w-100 form" @submit="onSubmit">
      <h5>Empresa</h5>

      <b-row cols="1" style="padding-bottom:10px" v-if="idMerchant == 0">
        <b-col>
          <a-switch size="large" @change="handleMerchantType" checked-children="Pessoa Juridica"
            un-checked-children="Pessoa Fisica" default-checked />
        </b-col>
      </b-row>
      <hr />

      <b-row cols="3" v-if="merchantTypeCompany">
        <b-col>
          <b-form-group label="CNPJ" label-for="document">
            <b-form-input id="document" v-model="form.document" v-mask="'##.###.###/####-##'" required
              :state="documentValidation" placeholder="Documento" @change="handleMerchantDocument"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Razão Social" label-for="socialReason">
            <b-form-input v-if="!isLoadingBureau" id="socialReason" v-model="form.socialReason" required
              placeholder="Razão social"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Nome Fantasia" label-for="name">
            <b-form-input v-if="!isLoadingBureau" id="name" v-model="form.name" placeholder="Nome"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Inscrição estadual" label-for="stateSubscription">
            <b-form-input v-if="!isLoadingBureau" id="stateSubscription" v-model="form.stateSubscription"
              placeholder="Inscrição estadual"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="CNAE" label-for="cnae">
            <b-form-input v-if="!isLoadingBureau" id="cnae" v-model="form.CNAE" required
              placeholder="CNAE"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row cols="3" v-if="!merchantTypeCompany">
        <b-col>
          <b-form-group label="CPF" label-for="document">
            <b-form-input id="document" v-model="form.document" v-mask="'###.###.###-##'" required v-validate="cpf"
              placeholder="documento" :state="documentValidation"></b-form-input>

          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Data de Nascimento" label-for="birthDate">
            <b-form-input id="birthDate" v-model="form.birthDate" required v-mask="'##/##/####'"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Nome" label-for="merchantPerson">
            <b-form-input id="merchantPerson" v-if="!isLoadingBureau" v-model="form.socialReason" required
              placeholder="Nome"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Nome Fantasia" label-for="name">
            <b-form-input v-if="!isLoadingBureau" id="name" v-model="form.name" placeholder="Nome"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row cols="3">
        <b-col v-if="idMerchant > 0">
          <b-form-group label="Status" label-for="Status">
            <a-select v-model="form.idMerchantStatus" :required="true" ref="statusMerchant"
              :name="`statusMerchant${_uid}`">
              <a-select-option value="null">
                Selecione
              </a-select-option>
              <a-select-option :value="item.idMerchantStatus" v-for="(item, index) in statusMerchant"
                :key="`statusMerchant-${index}`">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Email" label-for="email">
            <b-form-input v-if="!isLoadingBureau" id="email" v-model="form.email" type="email" required
              placeholder="Email"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Telefone" label-for="phone">
            <b-form-input v-if="!isLoadingBureau" id="phone" v-model="form.phoneNumber" required
              v-mask="'(##) #####-####'" placeholder="Telefone"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="MCC">
            <b-spinner v-if="!mcc.length" variant="primary" label="Spinning"></b-spinner>
            <b-select v-else required v-model="form.idMcc" ref="mcc" :name="`mcc${_uid}`">
              <b-select-option :value="null">
                Selecione
              </b-select-option>
              <b-select-option :value="item.id" v-for="(item, index) in mcc" :key="`mcc-${index}`" required>
                {{ item.description }}
              </b-select-option>
            </b-select>
          </b-form-group>
        </b-col>

        <b-col v-if="showCostCenter">
          <b-form-group label="Centro de Custo">
            <b-spinner v-if="!costCenters.length" variant="primary" label="Spinning"></b-spinner>
            <a-select v-else default-value="null" v-model="form.idCostCenter">
              <a-select-option value="null">
                Selecione
              </a-select-option>
              <a-select-option :value="item.idCostCenter" v-for="(item, index) in costCenters"
                :key="`costcenterID-${index}`">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Cep" label-for="zipCode">
            <b-form-input v-if="!isLoadingBureau" id="zipCode" v-model="form.address.zipCode" required
              @change="handleZipCode" v-mask="'#####-###'" placeholder="Cep"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>

      </b-row>

      <h5>Endereço</h5>
      <hr />
      <b-row cols="3">
        <b-col>
          <b-form-group label="Logradouro" label-for="street">
            <b-form-input v-if="!isLoadingZipcodeBureau" id="street" v-model="form.address.street" required
              placeholder=""></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Número" label-for="number">
            <b-form-input v-if="!isLoadingZipcodeBureau" id="number" v-model="form.address.number" required
              placeholder="Número"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Complemento" label-for="complement">
            <b-form-input v-if="!isLoadingZipcodeBureau" id="complement" v-model="form.address.complement"
              placeholder="Complemento"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Bairro" label-for="district">
            <b-form-input v-if="!isLoadingZipcodeBureau" id="district" v-model="form.address.district" required
              placeholder="Bairro"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="Cidade" label-for="city">
            <b-form-input v-if="!isLoadingZipcodeBureau" id="city" v-model="form.address.city" required
              placeholder="Cidade"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group label="UF" label-for="addressUF">
            <b-form-input v-if="!isLoadingZipcodeBureau" id="addressUF" v-model="form.address.UF" required
              placeholder="UF"></b-form-input>
            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
      </b-row>
      <hr />
      <h5>KYC- Conheça seu cliente</h5>
      <b-row align-h="start">
        <b-col cols="2">
          <b-form-group label="Abertura" label-for="merchantOpenTime">
            <a-time-picker id="merchantOpenTime" v-model="form.opening" required v-if="!isLoadingBureau"
              placeholder="Selecione a hora" format="HH:mm" />

            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label="Fechamento" label-for="merchantCloseTime">
            <a-time-picker id="merchantCloseTime" v-model="form.closing" required v-if="!isLoadingBureau"
              placeholder="Selecione a hora" format="HH:mm" />

            <b-spinner v-else variant="primary" label="Spinning"></b-spinner>
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group label="Faturamento" label-for="billingForecast">
            <b-form-input id="billingForecast" v-model="form.billingForecast" required v-money="money"
              placeholder="Faturamento"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Funcionamento" label-for="openningDays">
            <a-select mode="multiple" :default-value="form.workingDays" v-model="form.workingDays" style="width: 100%"
              placeholder="Selecione">
              <a-select-option :key="1">
                Dias úteis
              </a-select-option>
              <a-select-option :key="2">
                Sábado
              </a-select-option>
              <a-select-option :key="3">
                Domingo
              </a-select-option>
              <a-select-option :key="4">
                Feriado
              </a-select-option>
            </a-select>
          </b-form-group>
        </b-col>
      </b-row>

      <hr v-if="false"  />
      <h5 v-if="false" >Dados Bancários</h5>
      <div v-if="false" class="row">
        <div class="col-xl">
          <b-form-group label="Banco:" label-for="bankId" class="width-250">
            <v-select label="name" :filterable="false" :options="banks" :reduce="bank => bank.id"
              v-model="form.bankAccount.idBank" @search="onSearch">
              <template slot="no-options">Procure por nome</template>
              <template slot="option" slot-scope="option">{{
                option.name
                }}</template>
              <template slot="selected-option" slot-scope="option">{{
                option.name
                }}</template>
            </v-select>
          </b-form-group>
        </div>
        <div class="col-xl">
          <b-form-group label="Agência:" label-for="agency" :state="agencyValidation">
            <b-form-input trim id="agency" v-model="form.bankAccount.agency" :state="agencyValidation"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-xl">
          <b-form-group label="Agência Digito:" label-for="agencyDigit" :state="agencyDigitValidation">
            <b-form-input trim type="number" id="agencyDigit" v-model="form.bankAccount.agencyDigit"
              :state="agencyDigitValidation"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-xl">

          <b-form-group label="Conta :" label-for="account" :state="accountValidation">
            <b-form-input trim id="account" v-model="form.bankAccount.account"
              :state="accountValidation"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-xl">
          <b-form-group label="Conta Digito:" label-for="accountDigit" :state="accountDigitValidation">
            <b-form-input trim id="accountDigit" type="number" v-model="form.bankAccount.accountDigit"
              :state="accountDigitValidation"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-xl">
          <b-form-group label="Tipo de Conta:" label-for="bankAccountType" class="width-150"
            :state="accountTypeValidation">
            <b-form-select id="idBankAccountType" :options="accountTypes" :state="accountTypeValidation"
              v-model="form.bankAccount.idBankAccountType"></b-form-select>
          </b-form-group>
        </div>

      </div>
      <hr v-if="false" />
      <h5 v-if="false">PIX</h5>
      <div v-if="false" class="row">
        <div class="col-md-2">
          <b-form-group>

            <a-switch @change="handlePixType" checked-children="Sim " un-checked-children="Não"
              :defaultChecked="form.bankAccount.idPixKeyType === 1" />
          </b-form-group>
        </div>


      </div>
      <div class="row mt-5">
        <div class="col-xl">
          <b-btn type="submit" class="col-md-2" variant="outline-primary" :disabled="loading || !documentValidation">
            Salvar
            <b-spinner small variant="primary" label="Spinning" v-show="loading"></b-spinner>
          </b-btn>
        </div>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import { get as _get, debounce as _debounce } from "lodash";
import { mask } from "@titou10/v-mask";
import { MerchantBurealResource } from "@/resources/MerchantBureal.resource.js";
import { MccResource } from "@/resources/Mcc.resource.js";
import { Validators } from "@/utils/validators.js";
import { MerchantsResource } from "@/resources/Merchants.resource.js";
import { MaskUtils } from "@/utils/MaskUtils.js";
import { VMoney } from "v-money";

import moment from "moment";


export default {
  directives: { mask, money: VMoney },
  props: {
    merchant: {
      type: Object,
      default: () => { }
    }
  },


  data() {
    console.log("merchant", this.merchant);

    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: true
      },
      statusMerchant: [],
      mcc: [],
      isValid: false,
      costCenters: [],
      loading: false,
      isLoadingBureau: false,
      isLoadingZipcodeBureau: false,
      idMerchant: _get(this.merchant, "idMerchant", 0),
      merchantTypeCompany:
        _get(this.merchant, "idMerchantType", 1) == 1 ? true : false,
      form: {
        document: _get(this.merchant, "document", ""),
        name: _get(this.merchant, "name", ""),
        idCostCenter: _get(this.merchant, "idCostCenter", null),
        idManager: _get(this.merchant, "idManager", null),
        socialReason: _get(this.merchant, "socialReason", ""),
        stateNumber: _get(this.merchant, "stateNumber", ""),
        idMcc: _get(this.merchant, "idMcc", ""),
        fullName: _get(this.merchant, "fullName", ""),
        phoneNumber: _get(this.merchant, "phone", ""),

        billingForecast: parseFloat(_get(this.merchant, "billingForecast", 0)).toFixed(2),

        stateSubscription: _get(this.merchant, "stateSubscription", ""),
        CNAE: _get(this.merchant, "cnae", ""),

        fgActive: _get(this.merchant, "fgActive", false),
        idMerchantStatus: _get(this.merchant, "idMerchantStatus", ""),
        email: _get(this.merchant, "email", ""),
        opening: moment(_get(this.merchant, "openingTime", "09:00"), 'HH:mm'),
        closing: moment(_get(this.merchant, "closingTime", "18:00"), 'HH:mm'),
        workingDays: _get(this.merchant, "workingDays", [1, 2, 3]),
        birthDate: moment(_get(this.merchant, "birthDate", "")).isValid()
          ? moment(_get(this.merchant, "birthDate", "")).format("DDMMYYYY")
          : "",
        address: {
          idAddress: _get(this.merchant.merchantAddress, "idAddress", null),
          street: _get(this.merchant.merchantAddress, "street", ""),
          district: _get(this.merchant.merchantAddress, "district", ""),
          city: _get(this.merchant.merchantAddress, "city", ""),
          number: _get(this.merchant.merchantAddress, "number", ""),
          complement: _get(this.merchant.merchantAddress, "complement", ""),
          UF: _get(this.merchant.merchantAddress, "uf", ""),
          zipCode: _get(this.merchant.merchantAddress, "zipCode", "")
        },

        bankAccount: {
          idMerchantBankAccount: _get(
            this.merchant.merchantBankAccount,
            "idMerchantBankAccount",
            null
          ),
          idBank: _get(this.merchant.merchantBankAccount, "idBank", null),
          agency: _get(this.merchant.merchantBankAccount, "agency", ""),
          agencyDigit: _get(
            this.merchant.merchantBankAccount,
            "agencyDigit",
            null
          ),
          account: _get(this.merchant.merchantBankAccount, "account", ""),
          accountDigit: _get(
            this.merchant.merchantBankAccount,
            "accountDigit",
            ""
          ),
          idBankAccountType: _get(this.merchant.merchantBankAccount, "idBankAccountType", ""),
          idPixKeyType: _get(this.merchant.merchantBankAccount, "idPixKeyType", null),
          pixKeyValue: _get(this.merchant.merchantBankAccount, "pixKeyValue", "")
        }
      },
      banks: [
        this.merchant
          ? {
            id: _get(this.merchant.merchantBankAccount, "idBank", ""),
            name: _get(this.merchant.merchantBankAccount, "bankName", "")
          }
          : null
      ],
      selectedBank: null,
      accountTypes: [
        { value: "1", text: "Poupança" },
        { value: "2", text: "Conta Corrente" }
      ],
      fgPix: false,

    };
  },
  computed: {
    showCostCenter() {
      try {
        let result = true;
        result &= !(parseInt(this.$store.getters.user.costcenter) > 0)

        return result;
      } catch (e) {
        return false;
      }
    },

    documentValidation() {

      if (this.form.document === null) return false;
      return ((this.merchantTypeCompany) ? Validators.validateCNPJ(this.form.document) : Validators.validateCPF(this.form.document));


    },

    agencyValidation() {
      if (this.form.bankAccount.idBank === null) {
        return null;
      }
      return (
        this.form.bankAccount.idBank !== null &&
        this.form.bankAccount.idBank !== ""
      );
    },
    agencyDigitValidation() {
      return null;
      // if (this.form.bankAccount.idBank === null) {
      //   return null;
      // }
      // return (
      //   this.form.bankAccount.idBank !== null &&
      //   this.form.bankAccount.agencyDigit !== ""
      // );
    },
    accountValidation() {
      if (this.form.bankAccount.idBank === null) {
        return null;
      }
      return (
        this.form.bankAccount.idBank !== null &&
        this.form.bankAccount.account !== ""
      );
    },
    accountDigitValidation() {
      if (this.form.bankAccount.idBank === null) {
        return null;
      }
      return (
        this.form.bankAccount.idBank !== null &&
        this.form.bankAccount.accountDigit !== ""
      );
    },



    accountTypeValidation() {
      if (this.form.bankAccount.idBank === null) {
        return null;
      }
      return (
        this.form.bankAccount.idBankAccountType !== null && this.form.bankAccount.idBankAccountType !== ""
      );
    }
  },
  watch: {
    form: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler(newVal) {
        this.$emit("input", newVal);
      }
    }
  },
  methods: {
    moment,
    getMerchantStatus() {
      MerchantsResource.getMerchantStatus({ index: 1, size: 50, name: "" })
        .then(result => {
          this.statusMerchant = result.data.payload.items;
        })
        .catch(e => {
          // Surpress
        });
    },

    getCostCenter() {
      this.$api
        .get("v1/CostCenter")
        .then(result => {
          this.costCenters = result.data.payload.items;
        })
        .catch(e => {
          // Surpress
        });
    },

    getMcc() {
      MccResource.getKeyValue()
        .then(response => {
          if (response.data.isSuccess) {
            this.mcc = response.data.payload;
          } else {
            throw "erro ao carregar mcc";
          }
        })
        .catch(e => {
          // Surpress
        });
    },

    handleZipCode(value) {
      if (value.length === 9 && !this.merchantTypeCompany) {
        value = MaskUtils.unFormat(value);
        this.isLoadingZipcodeBureau = true;
        MerchantBurealResource.getZipcodeInfo({ id: value })
          .then(result => {
            try {
              this.form.address.street = result.data.payload.logradouro;
              this.form.address.district = result.data.payload.bairro;
              this.form.address.city = result.data.payload.localidade;
              this.form.address.complement = result.data.payload.complemento;
              this.form.address.UF = result.data.payload.uf;
              this.isLoadingZipcodeBureau = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada..."
                  }
                }
              };
            }
          })
          .catch(e => {
            this.isLoadingZipcodeBureau = false;
            // Surpress
          });
      }
    },
    handlePersonMerchantDocument(value) {

      if (this.form.document.length == 14 && value.length == 10) {
        this.isLoadingBureau = true;

        MerchantBurealResource.getPerson2({
          document: MaskUtils.unFormat(this.form.document),
          birthDate: moment(value, "DD/MM/YYYY").format('YYYY-MM-DD')
        })
          .then(result => {
            try {

              if (result.data.payload.status == true) {
                this.form.name = result.data.payload.resultPersonBureal.nomeDaPf;

              }
              else {
                this.isLoadingBureau = false;
                this.form.name = '';
                this.$notification["error"]({
                  message: "Cpf ou data de nascimento inválida!",
                  description: ""
                });

              }


              // this.displayItens = this.itens[this.filtrosLocal.index].flat()
              // this.totalRows = 100; //result.data.payload.pageSettings.total;
              // this.loading = false
            } catch (e) {
              this.isLoadingBureau = false;
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada..."
                  }
                }
              };
            }
          })
          .catch(e => {
            // // Surpress
            this.isLoadingBureau = false;
          });
      }
    },

    handleMerchantDocument(value) {
      value = MaskUtils.unFormat(value);

      if (value.length == 14 && this.merchantTypeCompany) {
        this.isLoadingBureau = true;
        this.isLoadingZipcodeBureau = true;
        MerchantBurealResource.get({ id: value })
          .then(result => {
            try {
              let data = result.data.payload.resultMerchantBureal;
              result.data.payload.resultMerchantBureal;
              this.form.socialReason = data.nome;
              this.form.name = data.fantasia;
              this.form.email = data.email;
              this.form.stateSubscription = data.numeroDeInscricao;
              this.form.phoneNumber = data.telefone;
              this.form.address.street = data.logradouro;
              this.form.address.zipCode = data.cep;
              this.form.address.district = data.bairro;
              this.form.address.number = data.numero;
              this.form.address.city = data.municipio;
              this.form.address.complement = data.complemento;
              this.form.address.UF = data.uf;
              this.form.CNAE = data.atividadePrincipal.code;

              this.isLoadingZipcodeBureau = false;
              this.isLoadingBureau = false;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Erro ao realizar consulta"
                  }
                }
              };
            }
          })
          .catch(e => {
            // Surpress
            this.isLoadingBureau = false;
            this.isLoadingZipcodeBureau = false;
          });
      }
    },

    handleMerchantType(value) {
      this.form.document = MaskUtils.unFormat(this.form.document);
      this.merchantTypeCompany = value;
    },

    handlePixType(value) {
      this.fgPix = value;

    },

    async fetchBank() {
      await this.$api
        .get("v1/bank/keyvalue")
        .then(result => {
          this.banks = result.data.payload.map(item => {
            return {
              value: item.id,
              text: item.description
            };
          });
        })
        .catch(e => {
          // Surpress
        });
    },

    async onSubmit(e) {
      e.preventDefault();


      const data = {
        ...this.form,
        idBank: this.form.bankId,
        idMerchantType: this.merchantTypeCompany ? 1 : 2,
        phone: MaskUtils.unFormat(this.form.phoneNumber),
        idSaleChannel: parseInt(this.$store.getters.user.salechannel),

        idMerchant: this.merchant.idMerchant || 0,
        idBankAccount: this.merchant.idBankAccount
      };
      if (this.$route.params.id > 0 && data.idMerchant == 0) {
        data.idMerchant = parseInt(this.$route.params.id);
      }

      if (!this.showCostCenter) {
        data.idCostCenter = parseInt(this.$store.getters.user.costcenter);
      }
      // fix some masks  until send
      data.billingForecast = MaskUtils.unmaskMoney(data.billingForecast);
      data.document = MaskUtils.unFormat(data.document);
      // pix key,  only can be the document of merchant;
      if (this.fgPix === true) {
        data.bankAccount.idPixKeyType = 1;
        data.bankAccount.pixKeyValue = data.document;


      }
      else {
        data.bankAccount.idPixKeyType = null;
        data.bankAccount.pixKeyValue = null;

      }


      // pessoa fisica  set social reason as name
      if (data.idMerchantType == 2) {
        //  data.socialReason = data.name;
      } // pessoa fisica

      // set string as int when is a number
      data.address.number = String(data.address.number);

      data.bankAccount.idBankAccountType = parseInt(data.bankAccount.idBankAccountType);

      data.birthDate = moment(data.birthDate, 'DD/MM/YYYY').isValid()
        ? moment(data.birthDate, "DD-MM-YYYY").format("YYYY-MM-DD")
        : null;

      // merchant opening
      data.opening = moment(data.opening).isValid()
        ? moment(data.opening).format("HH:mm")
        : null;

      //merchant closing
      data.closing = moment(data.closing).isValid()
        ? moment(data.closing).format("HH:mm")
        : null;

      if (data.bankAccount.idBank !== null) {
        if (
          data.bankAccount.agency === "" ||
          data.bankAccount.account === "" ||
          data.bankAccount.accountDigit === ""
        ) {
          this.$notification["error"]({
            message: "Erro",
            description: "Dados bancários incompletos"
          });
          return;
        }
      }
      this.loading = true;
      const vm = this;
      data.idCostCenter = data.idCostCenter == "null" ? null : data.idCostCenter;
      if (data.idMerchant == 0) {
        data.idMerchantStatus = 1;

        MerchantsResource.registerMerchant(data)
          .then(result => {
            try {
              this.loading = false;
              this.idMerchant = result.data.payload;

              this.$notification["success"]({
                message: "Registro inserido",
                description: ""
              });


              this.$router.push({
                path: "/merchant"
              });

              //        this.$router.push({
              //        path: `/merchant/${this.idMerchant}/edit`
              //       });




            } catch (e) {
              this.$notification["error"]({
                message: e.response.data.failureReason,
                description: ""
              });
            }
          })
          .catch(e => {
            this.loading = false;

            if (e.response.status === 403) {
              this.$notification["error"]({
                message: `Perfil sem permissão para executar esssa operação.`,
                description: ""
              });
            }

            else if (e.response.data.failureReason.includes('Duplicate')) {
              this.$notification["error"]({
                message: `Merchant já cadastrado na base.`,
                description: ""
              });


            }
            else {


              this.$notification["error"]({
                message: `Ocorreu um erro ! Contate o suporte com o Id : ${e.response.data.traceId}`,
                description: ""
              });

            }

            // Surpress
            this.loading = false;
          });
      } else {
        MerchantsResource.updateMerchant(data)
          .then(result => {
            try {
              this.idMerchant = result.data.payload;
              this.loading = false;
              this.$notification["success"]({
                message: "Registro atualizado",
                description: ""
              });


            } catch (e) {
              this.$notification["error"]({
                message: e.response.data.failureReason,
                description: ""
              });
            }
          })
          .catch(e => {
            // Surpress
            this.loading = false;
          });
      }
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    search: _debounce((loading, search, vm) => {
      vm.$api
        .get("v1/bank/keyvalue", {
          params: {
            name: search
          }
        })
        .then(result => {
          loading(false);
          vm.banks = result.data.payload.map(item => ({
            id: item.id,
            name: item.description
          }));
        })
        .catch(e => {
          // Surpress
        });
    }, 350)
  },
  created() {
    this.getMcc();
    // primeiro momento da pagina, carrega os dados dos filtros...
    // verificar o quanto estes dados mudam para fazer um cache no vuex....
    this.getMerchantStatus();
    this.getCostCenter();
  }
};
</script>

<style lang="css">
.width-150 {
  width: 150px;
}

.form .is-invalid,
.form .is-valid {
  padding-right: 0;
}
</style>
